import React from 'react';
import cn from 'classnames';
import styles from './StationCardLoader.module.scss';


const StationCardLoader = () => {
    return (<div className={styles.container}>
        <div className='d-flex justify-content-center align-items-center w-100 h-100'>
        <div className='w-100'>
            <div className={cn(styles.imgSpin, 'od-spinner')} />
        </div>
        </div>
    </div>)
}

export default StationCardLoader;